import { createContext } from "react";

const CloudinaryContext = createContext();

export default CloudinaryContext;
